<template>
  <div class="row justify-content-center">
    <div
      v-for="item in items"
      :key="item.id"
      class="col-lg-4 col-md-6 wow move-up"
    >
      <div class="service-grid">
        <div class="ht-service-box--two text-center style-03">
          <router-link to="">
            <div class="image mb-20">
              <img
                :src="item.icon"
                class="img-fluid"
                alt="startup-box-icon-01"
              />
            </div>
            <div class="content">
              <h6 class="heading">{{ item.heading }}</h6>
              <div class="service_text">{{ item.text }}</div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ServicesSummary",
  data() {
    return {
      items: [
        {
          icon: require("../assets/img/icons/enterprise-systems-development.png"),
          heading: "Business Process Automation",
          text: "Are you handling too much paperwork, are your day to day business processes not automated. We can automate all you business processes, digitize your world, and help you do away with all your manual processes",
        },
        {
          icon: require("../assets/img/icons/startup-box-icon-01.png"),
          heading: "Web Development",
          text: "We build web platforms of all scales and sizes. Web applications and websites development is one our core services",
        },
        {
          icon: require("../assets/img/icons/startup-box-icon-02.png"),
          heading: "Social Media Chat Bots",
          text: "Reach your customers and also let your customers reach you through automated chat bots. Give your customers a rich experience through our customizable chatbots",
        },
        {
          icon: require("../assets/img/icons/startup-box-icon-06.png"),
          heading: "Web Design",
          text: "Where design meets both innovation and modernization.",
        },
        {
          icon: require("../assets/img/icons/systems-integrations.png"),
          heading: "System Integrations",
          text: "Do you have systems that you will they are connected, or you want system that can fetch or send data or information to another system. Look no further, we can help you with system integrations",
        },
      ],
    };
  },
};
</script>
